
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { EnrolledUser } from "@/types/attendance";
import { useAttendanceMutation } from "@/hooks/useAttendanceMutation";
import { useIsMobile } from "@/hooks/use-mobile";

interface AttendanceTableProps {
  enrolledUsers: EnrolledUser[];
  classId: string | undefined;
  selectedDate: string;
}

export const AttendanceTable = ({ enrolledUsers, classId, selectedDate }: AttendanceTableProps) => {
  const { mutate: updateAttendance, isPending: isUpdating } = useAttendanceMutation();
  const isMobile = useIsMobile();

  if (!enrolledUsers.length) {
    return <p className="text-center text-white/60 py-4">No se encontraron alumnos con los criterios de búsqueda</p>;
  }

  if (isMobile) {
    return (
      <div className="space-y-4">
        {enrolledUsers.map((user) => (
          <div key={user.id} className="bg-[#293233] p-4 rounded-lg border border-[#00C1D6]/20">
            <div className="mb-2">
              <div className="font-medium text-white">
                {user.profiles.first_name || ''} {user.profiles.last_name || ''}
                {!user.profiles.first_name && !user.profiles.last_name && user.profiles.username}
              </div>
              <div className="text-sm text-white/70">{user.profiles.username}</div>
            </div>
            <div className="flex justify-between items-center mt-3">
              <div className="flex items-center">
                <span className="text-white/80 mr-2">Asistió:</span>
                <Checkbox
                  checked={user.attendanceRecord?.attended || false}
                  disabled={isUpdating}
                  onCheckedChange={(checked) => {
                    updateAttendance({
                      classId,
                      userId: user.user_id,
                      attended: !!checked,
                      penalized: user.attendanceRecord?.penalized || false,
                      selectedDate
                    });
                  }}
                  className="data-[state=checked]:bg-[#00C1D6] data-[state=checked]:text-white border-white/40"
                />
              </div>
              <div className="flex items-center">
                <span className="text-white/80 mr-2">Penalizado:</span>
                <Checkbox
                  checked={user.attendanceRecord?.penalized || false}
                  disabled={isUpdating}
                  onCheckedChange={(checked) => {
                    updateAttendance({
                      classId,
                      userId: user.user_id,
                      attended: user.attendanceRecord?.attended || false,
                      penalized: !!checked,
                      selectedDate
                    });
                  }}
                  className="data-[state=checked]:bg-orange-500 data-[state=checked]:text-white border-white/40"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow className="border-[#00C1D6]/20">
          <TableHead className="text-white/80">Alumno</TableHead>
          <TableHead className="text-center text-white/80">Asistió</TableHead>
          <TableHead className="text-center text-white/80">Penalizado</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {enrolledUsers.map((user) => (
          <TableRow key={user.id} className="border-[#00C1D6]/20">
            <TableCell>
              <div className="font-medium text-white">
                {user.profiles.first_name || ''} {user.profiles.last_name || ''}
                {!user.profiles.first_name && !user.profiles.last_name && user.profiles.username}
              </div>
              <div className="text-sm text-white/70">{user.profiles.username}</div>
            </TableCell>
            <TableCell className="text-center">
              <div className="flex justify-center">
                <Checkbox
                  checked={user.attendanceRecord?.attended || false}
                  disabled={isUpdating}
                  onCheckedChange={(checked) => {
                    updateAttendance({
                      classId,
                      userId: user.user_id,
                      attended: !!checked,
                      penalized: user.attendanceRecord?.penalized || false,
                      selectedDate
                    });
                  }}
                  className="data-[state=checked]:bg-[#00C1D6] data-[state=checked]:text-white border-white/40"
                />
              </div>
            </TableCell>
            <TableCell className="text-center">
              <div className="flex justify-center">
                <Checkbox
                  checked={user.attendanceRecord?.penalized || false}
                  disabled={isUpdating}
                  onCheckedChange={(checked) => {
                    updateAttendance({
                      classId,
                      userId: user.user_id,
                      attended: user.attendanceRecord?.attended || false,
                      penalized: !!checked,
                      selectedDate
                    });
                  }}
                  className="data-[state=checked]:bg-orange-500 data-[state=checked]:text-white border-white/40"
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
